import { mediaQueries, palette } from '@centivo/react-components'
import styled from 'styled-components'

import { useGlobalState } from 'src/context/global'
import { ContentSection } from '../../../structure'

const MainInfoSectionTag = styled(ContentSection)`
  padding-bottom: 3.875rem;
  margin-bottom: 0;

  h2 {
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 1rem;
    color: ${palette.brand.darkGreen};
  }

  ul {
    display: grid;
    grid-template-columns: 100%;
    gap: 0.25rem;
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.39;
    padding: 0 1.25rem;
    justify-items: center;

    @media ${mediaQueries.desktop} {
      grid-template-columns: repeat(4, 25%);
      padding: 0;
    }

    li {
      background-color: ${palette.brand.lightPurple};
      padding: 1rem 1.5rem 2rem;
      min-height: 13.33em;
      max-width: 15.77em;
      width: 100%;
      border-radius: 10px;
      @media ${mediaQueries.desktop} {
        min-height: unset;
        max-width: unset;
      }

      > p {
        color: ${palette.brand.darkGray};
      }

      img {
        margin-bottom: 1rem;
      }
    }
  }
`

export const MainInfoSection = () => {
  const [{ appConfig }] = useGlobalState()
  const { withCentivo } = appConfig

  return (
    <MainInfoSectionTag>
      <h2>With Centivo, you’ll get:</h2>
      <ul>
        <li>
          <p>
            {withCentivo[0] ??
              'Affordable, predictable costs, so you know what you owe, if anything, before your visits.'}
          </p>
        </li>
        <li>
          <p>
            {withCentivo[1] ??
              'A primary care doctor to coordinate all your healthcare needs and guide you to trusted, in-network specialists and facilities.'}
          </p>
        </li>
        <li>
          <p>
            {withCentivo[2] ??
              'Dedicated hands-on member support by phone or through the Centivo app.'}
          </p>
        </li>
        <li>
          <p>
            {withCentivo[3] ??
              'A simple, straightforward plan with an easy-to-use app and member portal.'}
          </p>
        </li>
      </ul>
    </MainInfoSectionTag>
  )
}
